module.exports = __webpack_public_path__ + "img/email.ccb8aa61.svg";